import React from "react";
import styles from "./Price.module.css";

export type PriceProps = {
  className?: string;
  is: React.ReactNode;
  label?: string;
  was?: React.ReactNode;
  stacked?: boolean;
  size?: "medium" | "large";
} & Omit<JSX.IntrinsicElements["p"], "children">;

export function Price({
  className = "",
  is,
  was,
  label,
  stacked = false,
  size = "medium",
  ...props
}: PriceProps) {
  return (
    <div
      className={`${styles.price} ${className}`}
      data-stacked={stacked}
      data-size={size}
      {...props}
    >
      <p className={styles.is}>
        {label && <s className={styles.label}>{label}</s>}
        {is}
      </p>
      {was && <s className={styles.was}>{was}</s>}
    </div>
  );
}

Price.displayName = "Price";
